import { createDateInNorwegianTime as d } from '@/services/new-utils.ts';

export const MARCH_2026_CAMPAIGN_END_DATE = d(2026, 4, 4, 12, 0);
